import * as THREE from 'three';

export class Projector {
  private readonly raycaster = new THREE.Raycaster();
  private readonly groundPlane = new THREE.Plane(new THREE.Vector3(0, 1, 0), 0);
  private readonly target = new THREE.Vector3();
  private readonly ndcVec = new THREE.Vector2();

  constructor(private readonly camera: THREE.Camera) {}

  toWorld(ndcX: number, ndcY: number): THREE.Vector3 | null {
    this.ndcVec.set(ndcX, ndcY);
    this.raycaster.setFromCamera(this.ndcVec, this.camera);
    const hit = this.raycaster.ray.intersectPlane(this.groundPlane, this.target);
    return hit ? this.target.clone() : null;
  }
}
